import React from "react";

const InputPasswordValidation = React.createClass({
    propTypes: {
        onParentChange: React.PropTypes.func
    },

    getDefaultProps: function () {
        return {
            allowIdenticalLetters: true,
            allowAphabeticalChars: true,
            allowNumericChars: true,
            allowSpecialChars: true,
            allowCaseSensitiveChars: true,
            allowConsecutiveNumericChars: true,
            allowRepeatPosition: true,
            allowIdenticalChars: true,
            minCharsAllowed: 8,
            maxCharsAllowed: 32,
            isEdition: false
        };
    },

    getInitialState: function () {
        return {
            value: this.props.clave,
            claveOriginal: this.props.clave,
            showPassword: false,
            showInput:true,
            oneAphabeticalChar: false,
            oneNumericChar: false,
            oneSpecialChar: false,
            minChars: false,
            lowerUpperChar: false,
            consecutiveNumbers: true,
            identicalChars: true,
            showPopup: false,
            repeatPosition: false
        };
    },

    onInputPassChange: function (event) {
        this.doValidations(event, event.target.value, true);
    },
    IsNumber: function (valor) {
        var estado = false;

        if (valor >= 0) {
            estado = true;
        } else {
            estado = false;
        }

        return estado;
    },
    doValidations(event, newValue, raiseParentEvent) {
        let status = true;
        let msgError = undefined;
        let isValid = true;
        let regExp = undefined;
        let regExpAux = undefined;

        if(newValue == "" && !this.state.showPassword){
            this.setState({showPassword:false});
            this.setState({showInput:true});
        }

        if (this.props.allowAphabeticalChars) {
            regExp = /[a-z\u00f1\u00d1]/gi;
            status = regExp.test(newValue);
            if (!status) {
                isValid = false;
            }
            this.setState({ oneAphabeticalChar: status });
        }

        if (this.props.allowSpecialChars) {
            regExp = /[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]/g;
            status = regExp.test(newValue);
            if (!status) {
                isValid = false;
            }
            this.setState({ oneSpecialChar: status });
        }

        if (this.props.allowNumericChars) {
            regExp = /[0-9]/g;
            status = regExp.test(newValue);
            if (!status) {
                isValid = false;
            }
            this.setState({ oneNumericChar: status });
        }

        if (this.props.allowCaseSensitiveChars) {
            regExp = /[a-z\u00f1]/g;
            regExpAux = /[A-Z\u00d1]/g;
            status = regExp.test(newValue) && regExpAux.test(newValue);
            if (!status) {
                isValid = false;
            }
            this.setState({ lowerUpperChar: status });
        }

        /*PermiteCaracteresIguales = allowIdenticalChars
        PermiteLetrasConsecutivas = allowConsecutiveLetters, false indica que las letras no pueden ser repetidas en todo el password
        PermiteNrosConsecutivos = allowConsecutiveNumericChars, false indica que las letras no pueden ser repetidas en todo el password 
        */
        // Valida que la clave no tenga caracteres iguales..
        if (this.props.allowIdenticalChars && newValue != "") {
            if(this.props.allowConsecutiveNumericChars && this.props.allowConsecutiveLetters)//Si no permite numeros y letras repetidos consecutivos
            {
                regExp = /^(?!.*([A-Za-z\00f1\00d1\d#@$%&'!"-?.,;+_*-])\1{1}).+$/;

                status = regExp.test(newValue);
                if (!status) {
                     isValid = false;
                }
                this.setState({ identicalChars: status });
            }
            else if(!this.props.allowConsecutiveNumericChars && !this.props.allowConsecutiveLetters)//Si no se permiten numeros ni letras repetidos en todo el password
            {
                regExp = /^(?:([A-Za-z\00f1\00d1\d#@$%&'!"-?.,;+_*-])(?!.*\1))*$/;//validacion para letras y numeros repetidos

                status = regExp.test(newValue);
                if (!status) {
                     isValid = false;
                }
                this.setState({ identicalChars: status });
            }
            else if(this.props.allowConsecutiveNumericChars && !this.props.allowConsecutiveLetters)//si no permite numeros repetidos consecutivos y no permite letras repetidas(no necesariamente consecutivas)
            {
                regExp = /^(?!.*([0-9\s])\1{1}).+$/; //validacion numeros repetidos consecutivos
                regExpAux = /^(?:([A-Za-z\00f1\00d1\d#@$%&'!"-?.,;])(?!.*\1)|([0-9]*))*$/;//validacion letras repetidas no necesariamente consecutivas

                status = regExp.test(newValue) && regExpAux.test(newValue);
                if (!status) {
                     isValid = false;
                }
                this.setState({ identicalChars: status });
            }
            else if(!this.props.allowConsecutiveNumericChars && this.props.allowConsecutiveLetters)//no permite numeros repetidos en todo el password, no permite letras repetidas consecutivas
            {
                regExp = /^(?:([0-9])(?!.*\1)|([A-Za-z#@$%&'!.,;+_*-]*))*$/;//validacion para numeros repetidos no necesariamente consecutivos
                regExpAux = /^(?!.*([A-Za-z\s\00f1\00d1#@$%&'!.,;+_*-])\1{1}).+$/;//validacion para letras repetidas de manera consecutiva

                status = regExp.test(newValue) && regExpAux.test(newValue);
                if (!status) {
                     isValid = false;
                }
                this.setState({ identicalChars: status });
            }

            if(newValue == "")
                this.setState({identicalChars: true});
            
            //regExp = /^(?:([A-Za-z\u00f1\u00d1\d#@$%&'!"-?.,;])(?!.*\1))*$/g;
            // regExp =/^([a-z])\1+$/;
            //if (this.props.allowIdenticalLetters) {
            /*} else {
                status = true;
                var palabra = newValue;
                var arrayLetras = [];
                for (var i = 0; i < palabra.length; i++) {
                    if (!this.IsNumber(palabra.charAt(i))) {
                        arrayLetras.push(palabra.charAt(i));
                    }
                }
                for (var i = 0; i < palabra.length; i++) {
                    var result = arrayLetras.filter(item => item == palabra.charAt(i));
                    if (result.length >= 2) {
                        status = false;
                        break;
                    }
                }
                if (!status) {
                    isValid = false;
                }
                this.setState({ identicalChars: status });
            }*/
            //allowConsecutiveNumericChars
            /*
            if (this.props.allowConsecutiveNumericChars) {
                regExp = /(?:0(?=0)|1(?=1)|2(?=2)|3(?=3)|4(?=4)|5(?=5)|6(?=6)|7(?=7)|8(?=8)|9(?=9))\d/g;

                status = !regExp.test(newValue);
                if (!status) {
                    isValid = false;
                }
                this.setState({ consecutiveNumbers: status });

            } else {
                status = true;
                var palabra = newValue;
                var arrayLetras2 = [];
                for (var i = 0; i < palabra.length; i++) {
                    if (this.IsNumber(palabra.charAt(i))) {
                        arrayLetras2.push(palabra.charAt(i));
                    }
                }
                for (var i = 0; i < palabra.length; i++) {
                    var result = arrayLetras2.filter(item => item == palabra.charAt(i));
                    if (result.length >= 2) {
                        status = false;
                        break;
                    }
                }
                if (!status && arrayLetras2.length != 0) {
                    isValid = false;
                }
                this.setState({ consecutiveNumbers: status });
            }*/


        }

        status = this.props.minCharsAllowed <= newValue.length;
        if (!status) { isValid = false; }
        this.setState({ value: newValue, minChars: status });

        if (raiseParentEvent) {
            event.statusInputPass = isValid;
            this.props.onParentChange(event);
        }
    },

    showPasswordHandle: function (e) {
        this.setState({ showPassword: !this.state.showPassword });
    },

    activarInputPassword: function (e) {
        this.setState({ showInput: false });
    },

    componentDidMount: function () {
        this.doValidations(undefined, this.state.value || "", false);
    },

    render: function () {
        return (<div className="password">
            <div className="row bottom-separator-xxs">
                <div className="col-xs-12 fields">
                    {/*!this.props.isEdition ? <span className={"clickable glyphicon "
                        + (this.state.showPassword ? "glyphicon-eye-open" : "glyphicon-eye-close")}
                        onClick={(event) => this.showPasswordHandle(event)}>
                    </span> : null*/}

                    <span className={"clickable glyphicon " + (this.state.showPassword ? "glyphicon-eye-open" : "glyphicon-eye-close")}
                        onClick={(event) => this.showPasswordHandle(event)}>
                    </span>

                    <input className={"form-control default-input " + (this.state.showPassword ? "" : "pw")}
                        value={this.state.value}
                        maxLength={this.props.maxCharsAllowed}
                        onChange={(event) => this.onInputPassChange(event)}
                        defaultValue={this.state.claveOriginal}
                        /*type={this.state.showPassword ? "input" : "password"}*/
                        type="input"
                        autoComplete="off"
                        {...this.props} />
                </div>
            </div>

            <div className="row password-item">
                {this.props.allowAphabeticalChars &&
                    <div className="col-xs-12 col-sm-6">
                        <label className={"dot-2 " + (this.state.oneAphabeticalChar ? "active" : "")} >
                            Al menos un caracter alfabético</label>
                    </div>}

                {this.props.allowNumericChars &&
                    <div className="col-xs-12 col-sm-6">
                        <label className={"dot-2 " + (this.state.oneNumericChar ? "active" : "")} >
                            Al menos un numero</label>
                    </div>}

                {this.props.allowSpecialChars &&
                    <div className="col-xs-12 col-sm-6">
                        <label className={"dot-2 " + (this.state.oneSpecialChar ? "active" : "")} >
                            Al menos un caracter especial</label>
                    </div>}

                {this.props.allowCaseSensitiveChars &&
                    <div className="col-xs-12 col-sm-6">
                        <label className={"dot-2 " + (this.state.lowerUpperChar ? "active" : "")} >
                            Al menos una letra mayúscula y minúscula</label>
                    </div>}

                <div className="col-xs-12 col-sm-6">
                    <label className={"dot-2 " + (this.state.minChars ? "active" : "")} >
                        {this.props.minCharsAllowed} caracteres como minimo</label>
                </div>

                {/*
                    <div className="col-xs-12 col-sm-6">
                        <label className={"dot-2 " + (this.state.consecutiveNumbers ? "active" : "")} >
                            No repetición de números seguidos</label>
                </div>*/}

                {
                    <div className="col-xs-12 col-sm-6">
                        <label className={"dot-2 " + (this.state.identicalChars ? "active" : "")} >
                            No repetición de caracteres</label>
                    </div>}
            </div>
        </div>);
    }
});

export default InputPasswordValidation;
